import { RouteConfig } from "vue-router";

// Models
import { config } from "@/models/constant/routes.constant";

const router: RouteConfig = {
  path: config.UPLOAD_TAX_INCOME_ROUTE.path,
  name: config.UPLOAD_TAX_INCOME_ROUTE.name,
  meta: config.UPLOAD_TAX_INCOME_ROUTE.meta,
  component: () => import("./UploadTaxIncome.vue"),
};

export default router;
